<template>
  <div id="root" v-if="getTenantSettingsStatus == 'success'">
    <el-container>
      <el-header height="auto">
        <router-link to="/"><div class="logo"></div></router-link>
        <a v-if="settings.back_button_link" class="back-to-site-button" :href="settings.back_button_link"><img v-if="settings.back_button_image_url" :src="settings.back_button_image_url" />{{settings.back_button_text || "Back to website"}}</a>
        <div class="header-controls" v-if="getSessionStatus == 'success'">
          <el-button @click="toggleHeaderControls" class="toggle-header-controls" type="primary" icon="el-icon-user" circle></el-button>
          <div :class="{'header-controls-content': true, visible: showHeaderControls}">
            <router-link :to="{name: 'account', params: {redirect: $route.name}}" v-if="!user"><el-button type="primary">Login / Register</el-button></router-link>
            <div v-if="user">
              <el-button @click="redirectToProfile" type="primary" icon="el-icon-edit" v-if="user.first_name">{{user.first_name | truncate(15)}}</el-button>
              <el-button @click="redirectToProfile" type="primary" icon="el-icon-edit" v-else>My Account</el-button>
              <el-button type="primary" v-on:click="doLogout">Logout</el-button>
            </div>
          </div>
        </div>
      </el-header>
    </el-container>
    <el-steps :active="active" align-center>
      <el-step v-for="config, route in routes" :title="config.label" @click.native="e => clickHandler(e, route)"></el-step>
    </el-steps>
    <div class="container">
      <router-view v-if="getSessionStatus == 'success'"></router-view>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import routesConfig from '../config/routes'
import facebookMixin from '../mixins/facebookMixin'

export default {
  mixins: [facebookMixin],
  methods: {
    toggleHeaderControls() {
      this.showHeaderControls = !this.showHeaderControls
    },
    clickHandler(e, route) {
      if (this.isRouteAllowedForStatus(route)) {
        this.$router.push({name: route})
      }
    },
    redirectToProfile() {
      if (this.$route.name != 'your-details')
        this.$router.push({name: 'profile', params: {redirect: this.$route.name}})
    },
    isRouteAllowedForStatus(name) {
      return this.routes[name].allowed_statuses.indexOf(this.order.status) !== -1
    },
    ...mapActions('session', ['logout']),
    doLogout() {
      if (typeof FB != 'undefined') {
        FB.getLoginStatus((response) => {
          if (response.status == 'connected') {
            FB.logout()
          }
        })
      }
      this.logout()
      this.$router.push({name: 'booking'})
    }
  },
  watch: {
    getTenantSettingsStatus() {
      if (this.getTenantSettingsStatus == 'success') {
        this.$i18n.locale = this.settings.locale
      }
    }
  },
  computed: {
    active() {
      const active = this.routeIndices.indexOf(this.$route.name)
      if (active !== -1)
        return active
      let n = 0
      for (let i in this.routes) {
        if (this.routes[i].related_routes && this.routes[i].related_routes.indexOf(this.$route.name) !== -1)
          return n
        n++
      }
    },
    routeIndices() {
      return Object.keys(this.routes)
    },
    ...mapState({
      getTenantSettingsStatus: state => state.settings.status.getTenantSettings,
      getSessionStatus: state => state.session.status.getSession,
      user: state => state.session.user,
      order: state => state.order.order,
      settings: state => state.settings.tenant
    })
  },
  created() {
    this.$store.dispatch('settings/getTenantSettings')
    this.fbInit()
  },
  data() {
    return {
      routes: routesConfig,
      showHeaderControls: false
    }
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Asap:600|Bungee&display=swap');
  @import "../styles/settings.scss";
  @import "../styles/mixins.scss";
  //@import 'element-ui/lib/theme-chalk/index.css';
  //@import "element-ui/packages/theme-chalk/src/index.scss";
  $--font-path: '~element-ui/lib/theme-chalk/fonts';

  $--sm: 541px;
  $--md: 1180px;
  $--lg: 1400px;
  $--xl: 1900px;
  $--color-success: $success-color;
  $--datepicker-text-hover-color: $success-color;
  @import "~element-ui/packages/theme-chalk/src/index";

  html {
    height: 100%;
  }
  body {
    height: 100%;
    font-family: $body-font;
    padding: 0;
    margin: 0;
  }

  #root {
    min-height: 100%;
    max-width: $container-max;
    margin: auto;
    background: #fff;
  }

  .container {
    flex: 1 1 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: $heading-font;
    color: $brand-color;
  }

  main {
    flex: 1;
    padding: 0 2em 2em 2em;
  }
  aside {
    padding: 0 2em 2em 2em;
    width: 30%;
  }


  nav {
    padding: 0 2em;
  }

  .el-input {
    max-width: 20em;
  }

  .el-badge__content.is-fixed {
    transform: none;
    position: relative;
    top: 0;
    right: 0;
    font-family: Arial;
    vertical-align: middle;
    font-size: 10px;
    margin-left: 0.5em;
  }

  .container, .el-steps {
    margin: auto;
    width: 100%;
    box-sizing: border-box;
  }

  .el-steps {
    padding: 2em;
    .el-step__line {
      background-color: $brand-color;
    }
    .el-step__icon, .el-step__title {
      cursor: pointer;
    }
    .el-step__head.is-wait {
      border-color: #d6999c;
      color: #d6999c;
    }
    .el-step__title.is-wait {
      color: #d6999c;
    }
    .is-finish {
      .el-step__title, .el-step__head, .el-step__line, .el-step__icon.is-text {
       color: $success-color;
       border-color: $success-color;
     }
     .el-step__line {
       background-color: $success-color;
     }
    }
    .el-step__title.is-finish {
      color: $success-color;
    }
    .el-step__title.is-process, .el-step__description.is-process, .el-step__head.is-process {
      color: $brand-color;
      border-color: $brand-color;
    }
  }

  .logo {
    max-width: 13em;
  }

  .el-card__header {
  }

  .el-button.el-button--primary {
    background: $primary-color;
    border: $primary-color;
  }

  header.el-header {
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.1);
    padding: 1em 1em 0;

    .header-controls {
      float: right;
    }
  }

  .header-style {
    line-height: 1.8em;
    text-align: left;
    font-family: $heading-font2;
    color: #fff;
    background-color: $brand-color;
    padding: 0.5rem 1rem;
    height: 1.8em;
    font-size: 15.21px;
    button.el-button {
      color: $brand-color;
      margin-right: 1em;
    }
  }

  .el-collapse-item .el-collapse-item__header {
    @extend .header-style;
  }

  .cart table {
    /*table-layout: fixed;*/
    caption {
      @extend .header-style;
      background-color: $primary-color;
      > i {
        font-size: 26px;
        vertical-align: middle;
        line-height: 80%;
        margin: 0 11px 0 1px;
      }
    }
    border-collapse: collapse;
    border: none;
    width: 100%;
    th {
      white-space: nowrap;
    }
    th, td {
      border-bottom: 1px solid #EBEEF5;
      font-size: 0.8rem;
      padding: 1rem 0.5rem;
      word-break: break-word;
    }
    tr:last-child {
      td, th {
        border-bottom: none;
      }
    }
    th {
      text-align: right;
      font-weight: bold;
    }
    tfoot {
      th, td {
        border-top: 2px solid #EBEEF5;
        font-size: 0.9rem;
      }
    }
  }

  .extras .el-collapse-item__content {
    padding-top: 1.5em;
  }

  // Fix date table width
  .el-date-picker .el-picker-panel__content table {
    table-layout: auto;
  }

  nav {
    margin-bottom: 2em;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0!important;
  }

  @media (min-width: $mobile-max + 1) {
    .toggle-header-controls {
      display: none;
    }

    .booking {
      .el-card__body {
        display: flex;
        align-items: center;
      }
    }
  }

  .booking {
    .el-form {
      display: flex;
      justify-content: start;
      align-items: flex-end;
      flex-wrap: wrap;
      margin-bottom: 1em;
    }

    .el-form-item--mini.el-form-item {
      box-sizing: border-box;
      margin: 0;
      box-sizing: border-box;
      flex: 0 0 49%;
      display: block;
    }

    .el-date-editor.el-input {
      width: 100%;
    }
  }

  @media (max-width: $mobile-max) {
    body {
      .el-container {
        flex-direction: column-reverse;
      }
      aside {
        width: auto;
        padding: 2em;
        box-sizing: border-box;
      }
      main {
        padding: 0 2em 1em;
      }

      nav {
        margin-bottom: 0;
      }

      .el-steps {
        padding: 1em;

        .el-step__title {
          font-size: 14px;
          line-height: normal;
        }

        .el-step__icon {
          width: 20px;
          height: 20px;
          font-size: 12px;
        }
      }
    }

    .header-controls-content {
      display: none;

      position: absolute;
      top: 74px;
      right: 0;
      z-index: 2;
      background: #fff;
      padding: 1em;
      border: 1px solid #ddd;

      &.visible {
        display: block;
      }
    }

    .booking {
      .el-card__header h3 {
        font-size: 1em;
      }

      .el-form {
        justify-content: space-between;
      }
    }

  }

    .custom-form .el-form-item__label {
      line-height: 1;
      padding-top: 13px;
    }

    .custom-form .description {
      color: #606266;
    }

</style>
